import ScopeConstants from "constants/ScopeConstants"

export const OutstandingTimesheetMineScope = {
    key: ScopeConstants.OUTSTANDING_TIMESHEET_MINE,
    selector: (state) => state.outstandingTimesheetsMine,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Timesheet/SearchMineOutstanding/",
    updateEndpoint: "/api/Timesheet/UpdateMine/",
}